@let vState = state();

@if (vState) {
  @if (vState.isLoading) {
    <div class="heading-md card-loading">Gathering people...</div>
  } @else if (vState.error) {
    <p class="card-error">Error loading people</p>
  } @else if (vState.data) {
    <div class="card-content">
      <a class="card-link" routerLink="people">
        <h3 class="white">
          <span class="heading-4xl white members-count">{{ count() }}</span>
          <span class="body-copy-sm">members</span>
        </h3>
      </a>
    </div>
  }
}
